import React from 'react';
import styles from './Header.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Header = ({
  children,
  OS
}) => {
  let androidStyle = OS !== 'iOS' ? {height: '44px'} : null;
  return (
    <div className={cx('Header')} style={androidStyle}>
      {children}
    </div>
  );
};

export default Header;


// WEBPACK FOOTER //
// ./src/app/intro/components/Header/Header.js